import { apiCall, baseUrl } from './config';
import { shouldUseMock } from '../../utils/common';
import { getCoursesMock, successMock } from './mock';
import { parseQueryParams } from '../../utils/queryParams';
import { coursePath } from '../../utils/paths';

export default {
  getApprovalRequests: (filters) => {
    if (shouldUseMock()) {
      return getCoursesMock(filters);
    }
    return apiCall(
      `${baseUrl}${coursePath}approval/course/list${parseQueryParams(filters)}`,
      'GET'
    );
  },
  approvalStatusSet: (id, body) => {
    if (shouldUseMock()) {
      return successMock();
    }
    return apiCall(
      `${baseUrl}${coursePath}course/${id}/approvalstatus`,
      'POST',
      body
    );
  },
};
